import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import UserFacing from "pages/UserFacing";
import Login from "pages/Login";
import DashBoard from "pages/DashBoard";
import Creation from "components/Creation";
import Admin from "pages/Admin";
import ScrollToTop from "components/ScrollToTop";
import Booking from "pages/Admin/components/Booking";
import Bookings from "pages/Admin/components/Bookings";
import DiscountCodes from "pages/Admin/components/DiscountCodes";
import Bubbles from "pages/Bubbles";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route
          exact
          path="/bubbles"
          render={() => {
            return <Bubbles />;
          }}
        />
        <Route
          exact
          path="/login"
          render={() => {
            return (
              <div className="container mx-auto">
                <div className="lg:w-6/12 mx-auto mt-8 pb-8 lg:shadow-md lg:rounded-xl">
                  <Login showBubbles={true} />
                </div>
              </div>
            );
          }}
        />
        <Route
          exact
          path="/admin"
          render={() => {
            return <Admin />;
          }}
        />
        <Route
          exact
          path="/admin/bookings"
          render={() => {
            return <Bookings />;
          }}
        />
        <Route
          path="/admin/bookings/:id"
          render={() => {
            return <Booking />;
          }}
        />
        <Route
          exact
          path="/admin/discount-codes"
          render={() => {
            return <DiscountCodes />;
          }}
        />
        <Route
          exact
          path="/"
          render={() => {
            return <DashBoard />;
          }}
        />
        <Route
          exact
          path="/new"
          render={() => {
            return <Creation />;
          }}
        />
        <Route
          path="/"
          render={() => {
            return <UserFacing />;
          }}
        />
      </Switch>
    </Router>
  );
}

export default App;
